export type UserFromRequest = {
  clientes: {
    idCliente: number;
    nome: string;
    usuarioAdministrador: boolean;
    ativo: boolean;
  }[];
  email: string;
  fazendas: { idFazenda: number; nome: string }[];
  idUsuario: number;
  login: string;
  nome: string;
  permissoes: { idGrupo: number; nome: string }[];
  retiros: { idRetiro: number; idFazenda: number; nome: string }[];
  usuarioInterno: boolean;
  usuarioTableau: boolean;
  acessoAoBenchmark?: boolean;
};

export enum UserFilterStatus {
  All = 0,
  Active = 1,
  Inactive = 2,
}

export enum UserPermission {
  CanAccessApp = "acessa_aplicativo",
  CanAccessPortal = "acessa_plataforma",
  FinalStock = "estoque_final",
  ImportMaps = "importar_mapas",
  ExportAndImportPastureCSV = "exportar_importar_csv_pasto",
  RegisterForageCycle = "cadastrar_ciclo_forragem",
  CanAccessBenchmark = "acessa_benchmark",
}

export type UserManagementFilter = {
  farmIds: number[];
  permissions: UserPermission[];
  retreatIds: number[];
  searchValue: string;
  status: UserFilterStatus | null;
};

export type NotifyFn = (message: string, variant: "error" | "success") => void;

export type FarmAndRetreatLink = {
  farm: { id: number; name: string };
  retreats: { id: number; name: string }[];
};
